import { useState } from 'react';

/**
 * Right-side slide-in panel with an optional full-screen toggle.
 * Used by detail panels (Stage Gates, RAID). `header` renders inside the
 * sticky header next to the controls; `children` is the scrollable body.
 */
export default function SlideOver({ onClose, header, children, allowFullScreen = true }) {
  const [full, setFull] = useState(false);
  return (
    <div className="slideover-overlay" onClick={onClose}>
      <div className={`slideover${full ? ' full' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="slideover-hdr">
          <div style={{ flex: 1, minWidth: 0 }}>{header}</div>
          <div className="slideover-actions">
            {allowFullScreen && (
              <button
                type="button"
                className="slideover-icon-btn"
                title={full ? 'Exit full screen' : 'Full screen'}
                onClick={() => setFull((f) => !f)}
              >
                {full ? '⤡' : '⤢'}
              </button>
            )}
            <button type="button" className="slideover-icon-btn" title="Close" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="slideover-body">{children}</div>
      </div>
    </div>
  );
}
